import { render, staticRenderFns } from "./ImageTab.vue?vue&type=template&id=7fb62864&scoped=true&"
import script from "./ImageTab.vue?vue&type=script&lang=js&"
export * from "./ImageTab.vue?vue&type=script&lang=js&"
import style0 from "./ImageTab.vue?vue&type=style&index=0&id=7fb62864&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb62864",
  null
  
)

export default component.exports